export type RouteKey = keyof typeof RouteDefinitions;

export const RouteDefinitions = {
  LOGIN: { path: "/login", roles: ["user"] as const },
  ONBOARDING: { path: "/onboarding", roles: ["user"] as const },
  SCAN: { path: "/scan", roles: ["user"] as const },
  CONFIRM: { path: "/scan/confirm", roles: ["user"] as const },
  DEVICES: { path: "/devices", roles: ["user"] as const },
  DEVICE_DETAIL: { path: "/devices/:id", roles: ["user"] as const },
  COMPANIES: { path: "/companies", roles: ["user"] as const },
  COMPANY_REGISTER: { path: "/companies/register", roles: ["user"] as const },
  COMPANY_DETAIL: { path: "/companies/:id", roles: ["user"] as const },
  COMPANY_EDIT: { path: "/companies/:id/edit", roles: ["user"] as const },
  INVITATION: { path: "/invitations/scan", roles: ["user"] as const },
  LICENSE: { path: "/license", roles: ["user"] as const },
  LICENSE_UPGRADE: { path: "/license/upgrade", roles: ["user"] as const },
  PROFILE: { path: "/profile", roles: ["user"] as const },
  // Legacy routes — needed for uikit legacy component stories
  STUDENT: { path: "/students/:id", roles: ["user"] as const },
  VACANCY: { path: "/vacancies/:id", roles: ["user"] as const },
  COMPANY: { path: "/companies/:id", roles: ["user"] as const },
} as const;

export const ConfigRoutes: { [K in keyof typeof RouteDefinitions]: K } =
  Object.fromEntries(
    Object.entries(RouteDefinitions).map(([key]) => [key, key]),
  ) as never;

export const getPath = (
  routeKey: RouteKey,
  params?: Record<string, string | number | undefined>,
): string => {
  const route = RouteDefinitions[routeKey];
  if (!route) throw new Error(`Route ${routeKey} not found`);

  let path: string = route.path;
  const queryParams: Record<string, string> = {};

  if (params) {
    for (const [key, value] of Object.entries(params)) {
      if (value === undefined || value === null) continue;
      // Если в шаблоне пути есть :key — подставляем значение в path
      // (например, /devices/:id → /devices/123)
      if (path.includes(`:${key}`)) {
        path = path.replace(`:${key}`, String(value));
      } else {
        // Остальные параметры добавляем как query-строку
        queryParams[key] = String(value);
      }
    }
  }

  if (Object.keys(queryParams).length > 0) {
    const query = new URLSearchParams(queryParams).toString();
    path = `${path}?${query}`;
  }

  return path;
};

export type RouteDefinition =
  (typeof RouteDefinitions)[keyof typeof RouteDefinitions];
export type RouteRole = RouteDefinition["roles"][number];
